import hosts from '@services/apiClient/hosts';

export class AuthController {
  // TODO: XCEED-3076 replace captcha url
  static async verifyCaptcha(code) {
    const response = await fetch(
      `${hosts.CAPTCHA_SERVICE}/v1/verify?platform=web&captchaCode=${code}`
    );
    const { success } = await response.json();
    return success;
  }
}
